import React, {Component} from "react";
import Closeable from "./Closeable";
import {KEYCODES} from "../utils/constants";
import {TextField} from "@vitalsource/vstui";
import "../../styles/ProductCard.css";
import {ProductData, ProjectDataItem} from "../types/StudioAPITypes";
import styled from "styled-components";

const StyledTextField = styled(TextField) `
  label {
    font-size: 16px;
    font-weight: 400;
    font-color: #2F2F39;
  }
`;

interface ProductEditPanelState {
  nameLength: number;
  nameInput: string;
  nameIsValid: boolean;
  shouldShakeTextField: boolean;
}

export interface ProductEditPanelProps {
  editProduct: (projectId: string) => void;
  updateProduct: (data: ProductData) => void;
  name: string;
  products: string[];
}

export default class ProductEditPanel extends Component<ProductEditPanelProps, ProductEditPanelState> {

  private editField: HTMLTextAreaElement | null = null;

  constructor(props: ProductEditPanelProps) {
    super(props);

    this.state = {
      nameLength: this.props.name.length,
      nameInput: this.props.name,
      nameIsValid: true,
      shouldShakeTextField: false,
    };

    this.clickOutside = this.clickOutside.bind(this);
    this.selectEscape = this.selectEscape.bind(this);
    this.close = this.close.bind(this);
    this.validate = this.validate.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.textfieldChange = this.textfieldChange.bind(this);
  }

  componentWillReceiveProps() {
    this.setState({
      nameLength: this.props.name.length
    })
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown, true);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown, true);
  }

  updateProduct() {
    if (this.state.nameInput !== this.props.name) {
      this.props.updateProduct({
        name: this.state.nameInput
      });
    }
      this.close();
  }

  handleKeyDown(e: KeyboardEvent) {

    if (e.which === KEYCODES.ENTER) {
      if (this.state.nameIsValid) {
        e.preventDefault();
        this.updateProduct();
      } else {
        this.setShakeState();
      }
    }
  }

  clickOutside(e: MouseEvent) {
    if (this.state.nameIsValid) {
      this.updateProduct()
    } else {
      e.stopPropagation();
      this.setShakeState();
    }
  }


  setShakeState() {
    this.setState({
      shouldShakeTextField: true
    });

    setTimeout(function (this: any){
      this.removeShakeState();
      this.clearTimeout();
    }.bind(this),500)
  }

  removeShakeState() {
    this.setState({
      shouldShakeTextField: false,
    });
  }

  selectEscape() {
    this.close()
  }

  textfieldChange(e: Event) {
    const target = e.target as HTMLInputElement;
    if (target) {
      const value = target.value.trim();

      if (this.editField) {
        this.editField.blur();
        this.editField.focus();
      }

      this.setState({
        nameLength: value.length,
        nameInput: value
      })
    }
  }

  close() {
    this.props.editProduct("");
  }

  validate() {
    if (this.editField) {
      let errorMessage = "";
      const value = this.editField.value.trim();
      const lowerCaseValue = value.toLowerCase();
      const lowerCaseProducts = this.props.products.map((product) => product.toLowerCase());
      const matchingIndex = lowerCaseProducts.indexOf(lowerCaseValue);
      if (matchingIndex !== -1 && this.props.name.toLowerCase()
        !== lowerCaseProducts[matchingIndex]) {
        errorMessage = "Name already exists"
      }

      if (value.length === 0) {
        errorMessage = "Please enter a name"
      }

      this.setState({
        nameIsValid: !errorMessage
      })

      return errorMessage;
    }
  }

  render() {
    return (
      <div className={"product-edit"}>
        <Closeable onClickOutside={this.clickOutside} onEscape={this.selectEscape}>
          <div className={this.state.shouldShakeTextField ? "product-edit__shake-field " : ""}>
            <StyledTextField
              fullWidth
              type={"text"}
              multiline
              rows={3}
              size={"medium"}
              label={"Name"}
              maxLength={200}
              defaultValue={this.props.name}
              onChange={this.textfieldChange}
              autoFocus
              validate={this.validate}
              nativeFormControlRef={(input: HTMLTextAreaElement) => this.editField = input}/>
          </div>
        </Closeable>
      </div>
    )
  }
}
